import React, { useRef } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';

import useCustomerProductsImport from 'core/hooks/useCustomerProductsImport';
import LoadingButton from 'Elements/Form/LoadingButton';

const HiddenInput = styled.input`
  display: none;
`;

export interface ImportButtonProps extends RouteComponentProps {
  customerId: number;
}

function ImportButton({ customerId, history }: ImportButtonProps) {
  const { importProducts, loading } = useCustomerProductsImport(customerId);
  const ref = useRef<HTMLInputElement>(null);

  const selectFile = () => ref.current && ref.current.click();

  const handleChange: React.FormEventHandler<HTMLInputElement> = event => {
    if (event.currentTarget.files != null) {
      importProducts(event.currentTarget.files[0]).then(history.goBack);
    }
  };

  return (
    <>
      <LoadingButton
        variant="contained"
        color="secondary"
        onClick={selectFile}
        loading={loading}
      >
        Tuo tiedosto
      </LoadingButton>

      <HiddenInput type="file" ref={ref} onChange={handleChange} />
    </>
  );
}

export default withRouter(ImportButton);
